import ENGLISH_FLAG from './flags/gb.png'
import GREEK_FLAG from './flags/gr.png'
import IMAGE_NOT_FOUND from './imageNotFound.jpg'
import LOGO from './logo/logo.png'
import PROMO from './logo/logo.png'
import SNF_LOGO from './interfase/logo.png'
import banner from './banner.png'
import banner2 from './bannerNew.png'
import background from './background.png'
import bigLogo from './download.png'
import bigLogoNew from './logoNew (1).svg'
import smallLogo from './download (2).png'
import together from './interfase/shutterStock.jpg'

const Images = {
	logo: SNF_LOGO,
	imageNotFound: IMAGE_NOT_FOUND,
	englishFlag: ENGLISH_FLAG,
	greekFlag: GREEK_FLAG,
	promo: PROMO,
	banner:banner2,
	background:background,
	bigLogo:bigLogo,
	smallLogo:smallLogo,
	bigLogoNew:bigLogoNew,
	together:together
}

export default Images